import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoDoc4detsGetRes } from "./abst/DtoDoc4detsGetRes";

export class DtoDoc4detsGetResImple extends DtoDoc4detsGetRes {
  public pager = new DtoApiPager();
}
